// Auth endpoints may return the useful error in responseData while message is null.
const nonEmptyMessage = (value: unknown): string | undefined =>
  typeof value === "string" && value.trim() ? value.trim() : undefined;

const responseMessage = (value: unknown): string | undefined => {
  if (typeof value === "object" && value !== null && !Array.isArray(value)) {
    return nonEmptyMessage((value as { message?: unknown }).message);
  }
  return nonEmptyMessage(value);
};

export const apiErrorMessage = (error: unknown, fallback: string): string => {
  const value = error as {
    response?: { data?: { responseData?: unknown; message?: unknown } };
    responseData?: unknown;
    message?: unknown;
  } | null;
  const body = value?.response?.data;
  return responseMessage(body?.responseData)
    ?? nonEmptyMessage(body?.message)
    ?? responseMessage(value?.responseData)
    ?? nonEmptyMessage(value?.message)
    ?? fallback;
};
